/* tslint:disable */
/* eslint-disable */
export enum OnboardingStoreStatusEnum {
  New = 'new',
  Lab = 'lab',
  Active = 'active',
  NonOrderingStore = 'nonOrderingStore',
  TemporarilyClosed = 'temporarilyClosed',
  PermanentlyClosed = 'permanentlyClosed'
}
